import React from "react";
import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { ScrollGrid } from "../../../../script/components/data-grid/data-grid-body/grid-bodys";
import { CommCol, DeciCol } from "../../../../script/components/data-grid/data-grid-column/grid-column";

export function DashQcisItemCard(props) {
    const { loading, data } = props;

    return (
        <DashCard
            title={"완제품 불량률 산출근거"}
            addClass={'subs'}
            loading={loading}
        >
            <ScrollGrid
                gridDataSource={data}
                height={250}
                mainKey={["work_numb", "rout_numb", "rout_seri"]}
                selection={'single'}
                direction={'vertical'}
            >
                {CommCol({ dataField: "work_numb", caption: "작업지시번호", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {CommCol({ dataField: "rout_numb", caption: "공정번호", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {CommCol({ dataField: "rout_seri", caption: "일보순번", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {CommCol({ dataField: "work_date", caption: "작업일자", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {CommCol({ dataField: "item_code", caption: "제품번호", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {CommCol({ dataField: "item_name", caption: "제 품 명", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {DeciCol({ dataField: "work_qtys", caption: "작업수량", allowFiltering: false, allowSorting: false, allowResizing: false })}
                {DeciCol({ dataField: "infe_qtys", caption: "불량수량", allowFiltering: false, allowSorting: false, allowResizing: false })}
            </ScrollGrid>
        </DashCard>
    )
}